import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "make-meet-page" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "make-meet-page-title" }, "请选择孵化站点", -1)
const _hoisted_3 = { class: "make-meet-page-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.siteList, (item) => {
        return (_openBlock(), _createBlock("div", {
          class: "make-meet-page-list-item",
          key: item.id,
          onClick: ($event: any) => (_ctx.next(item.id))
        }, _toDisplayString(item.siteName), 9, ["onClick"]))
      }), 128))
    ])
  ]))
}